<template>
  <section class="sick-number new-report__section">
    <h3 class="new-report__heading">NUMBER OF SICK DEER SIGHTED</h3>
    <section class="new-report__multiselect-container">
      <label for="sick-deer" class="new-report__label new-report__label--inline"
        >Sick Deer</label
      >
      <multiselect
        id="sick-deer"
        v-model="sickNumber"
        :options="countOptions"
        name="sick-deer"
        placeholder="-- Please Select --"
        class="new-report__input new-report__input--select"
        required=""
      />
    </section>
  </section>
</template>

<script>
import { get } from "lodash";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },

  data() {
    return {
      countOptions: ["None", "1", "2", "3–5", "6–10", "11+"],
    };
  },

  computed: {
    sickNumber: {
      get() {
        return get(this, "$store.state.incidentReport.sickDeer", "None");
      },
      set(val) {
        this.$store.commit("incidentReport/setSickDeer", val);
      },
    },
  },
};
</script>
